(function (module) {
    "use strict";

    module.component('marketDefinitionEdit', {
        template: require('./marketDefinitionEditComponent.html'),
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&'
        },
        controller: ['$scope', 'marketBrandService', 'productService', function(
            this: $TSFixMe,
            $scope: $TSFixMe,
            marketBrandService: $TSFixMe,
            productService: $TSFixMe
        ) {
            var $ctrl = this;

            $ctrl.$onInit = function () {
                $scope.model = $ctrl.resolve.model;
                marketBrandService.get().then((brands: $TSFixMe) => $ctrl.brands = brands);
                productService.get().then((products: $TSFixMe) => $ctrl.products = products);
            };
            $ctrl.ok = function () {
                $ctrl.close({
                    $value: $scope.model
                });
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({
                    $value: 'cancel'
                });
            };
        }]
    })

})(angular.module('topline.modules'));